export default __webpack_public_path__ + "static/media/Pinterest-Badge-White.91f4988d.png";